// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"40":"dd61476c","171":"8c8f1c95","252":"1fd94114","263":"babcab78","400":"f3ea17f8","507":"6c24aa92","968":"b9171276"}[chunkId] + ".chunk.js";
};